module.exports = __webpack_public_path__ + "img/home-1-cgm@2x.110b904d.png";